var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folders") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Bp-details---Occupant-",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folders",
    transform: "translate(-199.000000, -573.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.000000, 573.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.44,12.88 L26.88,12.88 L26.88,3.36 C26.88,3.05074217 26.6292578,2.8 26.32,2.8 L19.04,2.8 L19.04,0.56 C19.04,0.25074217 18.7892578,0 18.48,0 L2.8,0 C2.49074217,0 2.24,0.25074217 2.24,0.56 L2.24,8.4 L1.68,8.4 C0.75222658,8.4 0,9.15222658 0,10.08 L0,29.12 C0,29.4292578 0.25074217,29.68 0.56,29.68 L28.56,29.68 C28.8692578,29.68 29.12,29.4292578 29.12,29.12 L29.12,14.56 C29.12,13.6322266 28.3677734,12.88 27.44,12.88 Z M25.76,3.92 L25.76,12.88 L19.04,12.88 L19.04,3.92 L25.76,3.92 Z M17.92,3.36 L17.92,12.88 L11.2,12.88 L11.2,1.12 L17.92,1.12 L17.92,3.36 Z M3.36,1.12 L10.08,1.12 L10.08,11.0679297 L9.21019533,9.32859375 C8.92746092,8.75792967 8.34476566,8.3978125 7.70792967,8.4 L3.36,8.4 L3.36,1.12 Z M28,28.56 L1.12,28.56 L1.12,10.08 C1.12,9.77074217 1.37074217,9.51999814 1.68,9.51999814 L7.70792967,9.51999814 C7.92011717,9.51945316 8.11425783,9.63949217 8.20859375,9.82980467 L10.1387891,13.6901953 C10.1647657,13.7410547 10.1983984,13.7875391 10.2385937,13.8280078 C10.2473437,13.8370313 10.2580078,13.8433203 10.2675782,13.8515234 C10.3061328,13.8870703 10.3498828,13.9163282 10.3969141,13.9390234 C10.4127734,13.9475 10.4294532,13.9546093 10.4461328,13.9608984 C10.5079297,13.9855078 10.5735547,13.9986328 10.64,14 L27.44,14 C27.7492578,14 28,14.2507422 28,14.56 L28,28.56 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.88,6.16 L16.24,6.16 C16.5492578,6.16 16.8,5.90925783 16.8,5.6 L16.8,2.8 C16.8,2.49074217 16.5492578,2.24 16.24,2.24 L12.88,2.24 C12.5707422,2.24 12.32,2.49074217 12.32,2.8 L12.32,5.6 C12.32,5.90925783 12.5707422,6.16 12.88,6.16 Z M13.44,3.36 L15.68,3.36 L15.68,5.04 L13.44,5.04 L13.44,3.36 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.72,8.96 L24.08,8.96 C24.3892578,8.96 24.64,8.70925783 24.64,8.4 L24.64,5.6 C24.64,5.29074217 24.3892578,5.04 24.08,5.04 L20.72,5.04 C20.4107422,5.04 20.16,5.29074217 20.16,5.6 L20.16,8.4 C20.16,8.70925783 20.4107422,8.96 20.72,8.96 Z M21.28,6.16 L23.52,6.16 L23.52,7.84 L21.28,7.84 L21.28,6.16 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96,5.6 L8.96,2.8 C8.96,2.49074217 8.70925783,2.24 8.4,2.24 L5.04,2.24 C4.73074217,2.24 4.48,2.49074217 4.48,2.8 L4.48,5.6 C4.48,5.90925783 4.73074217,6.16 5.04,6.16 L8.4,6.16 C8.70925783,6.16 8.96,5.90925783 8.96,5.6 Z M7.84,5.04 L5.6,5.04 L5.6,3.36 L7.84,3.36 L7.84,5.04 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2,18.48 L17.36,18.48 C17.0507422,18.48 16.8,18.7307422 16.8,19.04 L16.8,25.76 C16.8,26.0692578 17.0507422,26.32 17.36,26.32 L25.2,26.32 C25.5092578,26.32 25.76,26.0692578 25.76,25.76 L25.76,19.04 C25.76,18.7307422 25.5092578,18.48 25.2,18.48 Z M24.64,25.2 L17.92,25.2 L17.92,19.6 L24.64,19.6 L24.64,25.2 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "19.04 20.72 23.52 20.72 23.52 21.84 19.04 21.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "19.04 22.96 23.52 22.96 23.52 24.08 19.04 24.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "2.24 25.2 3.36 25.2 3.36 26.32 2.24 26.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "4.48 25.2 5.6 25.2 5.6 26.32 4.48 26.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    points: "6.72 25.2 7.84 25.2 7.84 26.32 6.72 26.32"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.62a0ad788a954e62b41a2f8dc4239bd6.svg";
export { ForwardRef as ReactComponent };